/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

type VehicleDetailsNavParamItem = {
  text: string;
  value: string;
}

type VehicalDetailsNavParams = {
  answer: any;
  items: VehicleDetailsNavParamItem[];
  prompt: string;
  searchPlaceholder: string;
};

@Component({
  selector: 'app-vehicles-detail',
  templateUrl: './vehicles-detail.page.html',
  styleUrls: ['./vehicles-detail.page.scss']
})
export class VehiclesDetailPage implements OnInit {
  items: VehicleDetailsNavParamItem[];
  answer: any;
  prompt = '';
  searchPlaceholder = '';

  constructor(
    private navParams: NavParams,
    private popoverCtrl: PopoverController,
    private translate: TranslateService
  ) {}

  onClickRadio(item) {
    this.popoverCtrl.dismiss(item);
  }

  async filterList(evt) {
    this.items = this.navParams.data.items;
    const searchTerm = evt.srcElement.value;

    if (!searchTerm) {
      return;
    }

    this.items = this.items.filter((item) => {
      if (item.text && searchTerm) {
        return item.text.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
      }
    });
  }

  lastItem(index) {
    return this.items.length > 1 && index == this.items.length - 2; // 'Other' at end
  }

  ngOnInit() {
    const data = this.navParams.data as VehicalDetailsNavParams;

    this.searchPlaceholder = data.searchPlaceholder;
    this.items = data.items;
    this.answer = data.answer;
    this.prompt = data.prompt;
  }
}
